export const changeLatitudeReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_LATITUDE":
      return action.payload.latitude;
    default:
      return state;
  }
};
